/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import dateFormatter from './dateFormatter';
import timeFormatter from './timeFormatter';
import timestampFormatter from './timestampFormatter';
import numberFormatter from './numberFormatter';
import { Formatter } from './types';

const defaultFormatter: Formatter = {
    format(val: string): string {
        return val;
    }
};

const formatters: { [type: string]: Formatter } = {
    'java.math.BigDecimal': numberFormatter,
    'java.lang.Byte': numberFormatter,
    'java.lang.Short': numberFormatter,
    'java.lang.Integer': numberFormatter,
    'java.math.BigInteger': numberFormatter,
    'java.lang.Long': numberFormatter,
    'java.lang.Float': numberFormatter,
    'java.lang.Double': numberFormatter,
    'java.lang.Decimal': numberFormatter,
    'java.util.Date': dateFormatter,
    'java.sql.Date': dateFormatter,
    'java.sql.Time': timeFormatter,
    'java.sql.Timestamp': timestampFormatter,
    bigDecimal: numberFormatter,
    byte: numberFormatter,
    short: numberFormatter,
    integer: numberFormatter,
    bigInteger: numberFormatter,
    long: numberFormatter,
    float: numberFormatter,
    double: numberFormatter,
    decimal: numberFormatter,
    date: dateFormatter,
    time: timeFormatter,
    timestamp: timestampFormatter
};

export default function formattersFactory(type: string): Formatter {
    return formatters[type] || defaultFormatter;
}
